export default __webpack_public_path__ + "static/media/BudgetTracker.48ce1abf.gif";